const reviewConfig = {
    productList: {
        filterLayout: 'ReviewProductFilterLayout',
        listLayout: 'ReviewProductListLayout',
        paginationLayout: 'PaginationProductLayout',
        getFunc: 'getReview',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
        sortOptions: {
            keyName: 'sortColumn',
            orderName: 'sortType',
        },
        defaultSort: {
            key: 'likeCnt',
            order: 'desc'
        },
        deleteFunc: 'deleteReview',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName:'r_idxs',
        pageRow: 10,
        excelDownloadName:'상품 리뷰',
        excelParamSet:{excel:1},
        excelDownloadFunc:'review',
        listFailMsg: '데이터를 불러올 수 없습니다.',
    },
    brandList: {
        filterLayout: 'ReviewProductFilterLayout',
        listLayout: 'ReviewProductListLayout',
        paginationLayout: 'PaginationProductLayout',
        getFunc: 'getReview',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
        sortOptions: {
            keyName: 'sortColumn',
            orderName: 'sortType',
        },
        defaultSort: {
            key: 'likeCnt',
            order: 'desc'
        },
        deleteFunc: 'deleteReview',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName:'r_idx',
        pageRow: 10,
        excelDownloadName:'상품 리뷰',
        excelParamSet:{brandexcel:1},
        excelDownloadFunc:'review',
        listFailMsg: '데이터를 불러올 수 없습니다.',
    },
    updateReview: {
        writeLayouts: ['ReviewWriteDefaultLayout'],
        getFunc: 'getReview',
        detailApiParamSet: {
        },
        writeFunc: 'updateReview',
        writeApiParamSet: {
        },
        parsingData: {
            es_idx: 'es_idx', //스타일
            r_content: 'r_content', //내용
            mb_no: 'mb_no', //작성자
            updateReason: 'r_update_reason', //관리자 수정 사유
        },
        writeSuccessType: 1,
        writeFailMsg: '리뷰수정에 실패하였습니다.',
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        deleteFunc: 'deleteReview',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        directUrl: '',
        directType: 'back',
        fileInfo: [],
        deleteFilesName: ['deletePartReviewFiles'],
        keyName: 'r_idx',
        deleteKeyName:'r_idxs',
    },

    magazine: {
        filterLayout: 'ReviewFilterMagazineLayout',
        listLayout: 'ReviewListMagazineLayout',
        paginationLayout: 'PaginationReviewLayout',
        getFunc: 'getReviewMagazine',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
        pageRow: 10,
        listFailMsg: '데이터를 불러올 수 없습니다.',
        deleteFunc: 'deleteReviewMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName:'pr_idx',
        excelDownloadFunc: 'plan/review',
        excelDownloadName: '매거진 리뷰 목록',
        excelParamSet: {
            excel: 1
        }
    },
    detailMagazine: {
        writeLayouts: ['ReviewDetailMagazineLayout'],
        getFunc: 'getReviewMagazine',
        detailApiParamSet: {
        },
        keyName: 'pr_idx',
        deleteFunc: 'deleteReviewMagazine',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        directUrl: '',
        directType: 'back'
    },

    styling: {
        filterLayout: 'ReviewFilterStylingLayout',
        listLayout: 'ReviewListStylingLayout',
        paginationLayout: 'PaginationReviewLayout',
        getFunc: 'getReviewStyling',
        listApiParamSet: {
            ip: 1,
            sp: 10,
        },
        pageRow: 10,
        listFailMsg: '데이터를 불러올 수 없습니다.',
        deleteFunc: 'deleteReviewStyling',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        keyName:'rbf_idx',
        excelDownloadFunc: 'review/style',
        excelDownloadName: '스타일링 리뷰 목록',
        excelParamSet: {
            excel: 1
        }
    },
    detailStyling: {
        writeLayouts: ['ReviewDetailStylingLayout'],
        getFunc: 'getReviewStyling',
        detailApiParamSet: {
            f: 1,
        },
        keyName: 'rbs_idx',
        deleteFunc: 'deleteReviewStyling',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        directUrl: '',
        directType: 'back'
    },
}
export default {
    methods: {
        returnReviewConfig(type) {
            return reviewConfig[type];
        }
    },
    filterConfig: {
        na: { // 닉네임
            type: 'query',
            classname: 'searchInput'
        },
        mb_id: { // 아이디
            type: 'query',
            classname: 'searchInput'
        },
        ina: { // 상품명
            type: 'query',
            classname: 'searchInput'
        },
        i_name: { // 상품명
            type: 'query',
            classname: 'searchInput'
        },
        r_score: { //  별점
            type: 'terms',
            classname: 'filterScore',
        },
        r_point_status: { // 지급유형
            type: 'terms',
            classname: 'filterStatus',
        },
        icsd_part: { //  타입
            type: 'match',
            classname: 'filterType',
        },
        cr:{ // 시작일
            type: 'between',
            classname: 'filterDate'
        },
        id: { // 매거진 아이디
            type: 'query',
            classname: 'searchInput'
        },
        title: { // 매거진 명
            type: 'query',
            classname: 'searchInput'
        },
        content: { // 매거진 내용
            type: 'query',
            classname: 'searchInput'
        },
        gender: { // 매거진 성별
            type: 'match',
            classname: 'filterTypeGender'
        },
        review: { // 매거진 만족도
            type: 'match',
            classname: 'filterTypeReview'
        },
        mid: { // 스타일링 아이디
            type: 'query',
            classname: 'searchInput'
        },
        sex: { // 스타일링 성별
            type: 'match',
            classname: 'filterTypeSex'
        },
        eskeys: { // 스타일링 스타일
            type: 'terms',
            classname: 'filterTypeStyle'
        },
        rate: { // 스타일링 만족도
            type: 'match',
            classname: 'filterTypeRate'
        },
        reason: { // 스타일링 내용
            type: 'query',
            classname: 'searchInput'
        },
        tab: {
            type: 'noFilter',
            classname: 'tab',
        },
    }
}
